import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { CountriesService } from "../../../../services/country.service";
import { CountriesDataType } from "../../../../interfaces/admin.interface";

interface CountrySelectProps {
  setFieldValue: (field: string, value: any) => void;
  country_id: number | null;
  selectedName: string | undefined;
  setSelectedName: (value: string | undefined) => void;
}

const SelectCountry: React.FC<CountrySelectProps> = ({
  setFieldValue,
  country_id,
  selectedName,
  setSelectedName,
}) => {
  const [countries, setCountries] = useState<CountriesDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    CountriesService.getAllCountries()
      .then((response) => {
        setCountries(response?.data?.data);
        const selectedCountry = response?.data?.data?.find(
          (element: CountriesDataType) => element.id === country_id
        );
        setSelectedName(selectedCountry?.name);
      })
      .finally(() => setLoading(false));
  }, [country_id, setSelectedName]);

  return (
    <Select
      style={{ width: "100%", height: "46px" }}
      placeholder={loading ? "Ölkələr yüklənir..." : "Ölkə seçin"}
      options={countries?.map((element) => ({
        label: element.name,
        value: element.name,
      }))}
      value={selectedName}
      onChange={(newName) => {
        setSelectedName(newName);
        const selectedCountry = countries.find(
          (element) => element.name === newName
        );
        if (selectedCountry) {
          setFieldValue("country_id", selectedCountry.id);
        }
      }}
    />
  );
};

export default SelectCountry;
